import { ENUM_STATUS_GAME } from "constants"

import React from "react"

import BoxButton from "components/BoxButton"
import CustomButton from "components/CustomButton"
import { AiOutlineRobot } from "react-icons/ai"
import {  RiUser5Line } from "react-icons/ri"
import { randomNumber } from "utils"

const Wait = ({ amIsetShadow, setAmIsetShadow , setSeries , setStatus}) => {
    const handleSetup = async() => {
        const num1 = randomNumber(1, 9999999)
        let seri1 = `${num1}`
        seri1 = Array.from(new Array(7 - seri1.length), (val) => "0") + seri1

        const num2 = randomNumber(1, 9999999)
        let seri2 = `${num2}`
        seri2 = Array.from(new Array(7 - seri2.length), (val) => "0") + seri2

        setSeries([seri1 , seri2])
        setStatus(ENUM_STATUS_GAME.SET_SHADOW)
    }

    return (
        <>
            <p className="text-xl font-bold tracking-wide text-center">CHƠI VỚI MÁY</p>

            <>
                <div className="mt-8">
                    <p className="text-lg font-semibold">Ai là người giao bóng</p>

                    <div className="flex mt-2 space-x-3">
                        <BoxButton
                            className={ `${
                                amIsetShadow ? "bg-primary--light text-white border-0" : ""
                            }` }
                            icon={ <RiUser5Line size={ 24 } /> }
                            title="Tôi"
                            onClick={ () => setAmIsetShadow(true) }
                        />

                        <BoxButton
                            className={ `${
                                !amIsetShadow ? "bg-primary--light text-white border-0" : ""
                            }` }
                            icon={ <AiOutlineRobot size={ 24 } /> }
                            title="Máy"
                            onClick={ () => setAmIsetShadow(false) }
                        />
                    </div>
                </div>

                <CustomButton className="w-full h-[44px] mt-10" onClick={ handleSetup }>
                    Giao bóng
                </CustomButton>
            </>
        </>
    )
}

export default Wait
